import { get } from "lodash";
import { WagerTypeCodesEnum } from "@tvg/ts-types/Wager";
import { getACrossTheBoardLength, isDuplicate } from "./utils";
import { RunnerBI } from "../useGetRunnerFromBI";

const getSimpleBets = (
  type: string,
  selectedBetTypeCode: WagerTypeCodesEnum,
  selections: string[][],
  runner: RunnerBI,
  position?: number
) => {
  const isWinPlaceShow =
    selectedBetTypeCode === WagerTypeCodesEnum.WIN_PLACE_SHOW;
  const isAcrossTheBoardButton = type.toLowerCase() === "across the board";
  const currentSelections = [...selections];

  // get the correct length and positions for a specific button
  // or across the board by checking the bet type
  const indexes =
    type.toLowerCase() === "across the board"
      ? [...Array(getACrossTheBoardLength[selectedBetTypeCode]).keys()]
      : [position];
  // get the amount of times a specific number is placed
  const numberPresence = selections
    .map((items) => items.filter((item) => +item === +runner.biNumber))
    .flat();

  const filteredSelections =
    isAcrossTheBoardButton && numberPresence.length < indexes.length
      ? selections.map((items) =>
          items.filter((item) => +item !== +runner.biNumber)
        )
      : selections;

  const allowedPresenceByType = isWinPlaceShow ? 2 : 1;

  // using the correct array length, update all the correct positions
  // with new selections and the previous ones
  indexes.forEach((pos) => {
    if (numberPresence.length <= allowedPresenceByType) {
      const prev = get(filteredSelections, `[${pos}]`, []);
      currentSelections[pos || 0] = isDuplicate(prev, runner)
        ? prev.filter((item: string) => +item !== +runner.biNumber)
        : [...prev, `${runner.biNumber}`];
    } else {
      // in wp and wps this will execute if a row of numbers are all selected
      // this is a reversed remove of the selected button, unselect all except the one user clicked
      const numberOfPositions = [...Array(isWinPlaceShow ? 3 : 2).keys()];
      const positions = numberOfPositions.filter((p) => p !== position);

      positions.forEach((p) => {
        currentSelections[p] = currentSelections[p].filter(
          (s) => +s !== +runner.biNumber
        );
      });
    }
  });

  return currentSelections.map((current) =>
    current === undefined ? [] : current
  );
};

export default getSimpleBets;
